export const emojis = [
    {
        emoji: '🍏',
        text: 'Apfel',
    },
    {
        emoji: '🍎',
        text: 'Apfel',
    },
    {
        emoji: '🍐',
        text: 'Birne',
    },
    {
        emoji: '🍊',
        text: 'Mandarine',
    },
    {
        emoji: '🍋',
        text: 'Zitrone',
    },
    {
        emoji: '🍌',
        text: 'Banane',
    },
    {
        emoji: '🍉',
        text: 'Wassermelone',
    },
    {
        emoji: '🍇',
        text: 'Trauben',
    },
    {
        emoji: '🍓',
        text: 'Erdbeere',
    },
    {
        emoji: '🍈',
        text: 'Honigmelone',
    },
    {
        emoji: '🍒',
        text: 'Kirschen',
    },
    {
        emoji: '🍑',
        text: 'Pfirsich',
    },
    {
        emoji: '🍍',
        text: 'Ananas',
    },
    {
        emoji: '🥥',
        text: 'Kokosnuss',
    },
    {
        emoji: '🥝',
        text: 'Kiwi',
    },
    {
        emoji: '🍅',
        text: 'Tomate',
    },
    {
        emoji: '🍆',
        text: 'Aubergine',
    },
    {
        emoji: '🥑',
        text: 'Avocado',
    },
    {
        emoji: '🥦',
        text: 'Brokkoli',
    },
    {
        emoji: '🥒',
        text: 'Gurke',
    },
    {
        emoji: '🌶',
        text: 'Peperoni',
    },
    {
        emoji: '🌽',
        text: 'Mais',
    },
    {
        emoji: '🥕',
        text: 'Karotte',
    },
    {
        emoji: '🥔',
        text: 'Kartoffel',
    },
    {
        emoji: '🍠',
        text: 'Kartoffel',
    },
    {
        emoji: '🥐',
        text: 'Croissant',
    },
    {
        emoji: '🍞',
        text: 'Brot',
    },
    {
        emoji: '🥖',
        text: 'Brot',
    },
    {
        emoji: '🥨',
        text: 'Brezel',
    },
    {
        emoji: '🧀',
        text: 'Käse',
    },
    {
        emoji: '🥚',
        text: 'Eier',
    },
    {
        emoji: '🍳',
        text: 'Eier',
    },
    {
        emoji: '🥞',
        text: 'Pancake',
    },
    {
        emoji: '🥓',
        text: 'Bacon',
    },
    {
        emoji: '🥩',
        text: 'Fleisch',
    },
    {
        emoji: '🍗',
        text: 'Poulet',
    },
    {
        emoji: '🍖',
        text: 'Fleisch',
    },
    {
        emoji: '🌭',
        text: 'Hotdog',
    },
    {
        emoji: '🍔',
        text: 'Hamburger',
    },
    {
        emoji: '🍟',
        text: 'Pommes',
    },
    {
        emoji: '🍕',
        text: 'Pizza',
    },
    {
        emoji: '🥪',
        text: 'Sandwich',
    },
    {
        emoji: '🥙',
        text: 'Döner',
    },
    {
        emoji: '🌮',
        text: 'Taco',
    },
    {
        emoji: '🌯',
        text: 'Burrito',
    },
    {
        emoji: '🥗',
        text: 'Salat',
    },
    {
        emoji: '🥘',
        text: 'Pfannengericht',
    },
    {
        emoji: '🥫',
        text: 'Konserve',
    },
    {
        emoji: '🍝',
        text: 'Spaghetti',
    },
    {
        emoji: '🍜',
        text: 'Suppe',
    },
    {
        emoji: '🍲',
        text: 'Reis',
    },
    {
        emoji: '🍛',
        text: 'Reis',
    },
    {
        emoji: '🍣',
        text: 'Sushi',
    },
    {
        emoji: '🍱',
        text: 'Sushi',
    },
    {
        emoji: '🥟',
        text: 'Teig',
    },
    {
        emoji: '🍤',
        text: 'Crevetten',
    },
    {
        emoji: '🍙',
        text: 'Reis',
    },
    {
        emoji: '🍚',
        text: 'Reis',
    },
    {
        emoji: '🍘',
        text: 'Reis',
    },
    {
        emoji: '🍥',
        text: 'Fisch',
    },
    {
        emoji: '🥠',
        text: 'Glückskeks',
    },
    {
        emoji: '🍢',
        text: 'Spiessli',
    },
    {
        emoji: '🍡',
        text: 'Spiessli',
    },
    {
        emoji: '🍧',
        text: 'Glace',
    },
    {
        emoji: '🍨',
        text: 'Glace',
    },
    {
        emoji: '🍦',
        text: 'Glace',
    },
    {
        emoji: '🥧',
        text: 'Kuchen',
    },
    {
        emoji: '🍰',
        text: 'Torte',
    },
    {
        emoji: '🎂',
        text: 'Torte',
    },
    {
        emoji: '🍮',
        text: 'Pudding',
    },
    {
        emoji: '🍭',
        text: 'Lollypop',
    },
    {
        emoji: '🍬',
        text: 'Bonbon',
    },
    {
        emoji: '🍫',
        text: 'Schokolade',
    },
    {
        emoji: '🍿',
        text: 'Popcorn',
    },
    {
        emoji: '🍩',
        text: 'Donut',
    },
    {
        emoji: '🍪',
        text: 'Keks',
    },
    {
        emoji: '🌰',
        text: 'Kastanie',
    },
    {
        emoji: '🥜',
        text: 'Erdnuss',
    },
    {
        emoji: '🍯',
        text: 'Honig',
    },
    {
        emoji: '🥛',
        text: 'Milch',
    },
    {
        emoji: '🍼',
        text: 'Milch',
    },
    {
        emoji: '☕',
        text: 'Kaffe',
    },
    {
        emoji: '🍵',
        text: 'Tee',
    },
    {
        emoji: '🥤',
        text: 'Getränk',
    },
    {
        emoji: '🍶',
        text: 'Sake',
    },
    {
        emoji: '🍺',
        text: 'Bier',
    },
    {
        emoji: '🍻',
        text: 'Bier',
    },
    {
        emoji: '🥂',
        text: 'Champagne',
    },
    {
        emoji: '🍷',
        text: 'Wein',
    },
    {
        emoji: '🥃',
        text: 'Getränk',
    },
    {
        emoji: '🍸',
        text: 'Cocktail',
    },
    {
        emoji: '🍹',
        text: 'Cocktail',
    },
    {
        emoji: '🍾',
        text: 'Champagne',
    },
    {
        emoji: '🥄',
        text: 'Löffel',
    },
    {
        emoji: '🍴',
        text: 'Besteck',
    },
    {
        emoji: '🍽',
        text: 'Besteck',
    },
    {
        emoji: '🥣',
        text: 'Schüssel',
    },
    {
        emoji: '🥡',
        text: 'Takeaway',
    },
    {
        emoji: '🥢',
        text: 'Essstäbchen',
    },
    {
        emoji: '🐶',
        text: 'Hund',
    },
    {
        emoji: '🐕',
        text: 'Hund',
    },
    {
        emoji: '🐩',
        text: 'Hund',
    },
    {
        emoji: '🐱',
        text: 'Katze',
    },
    {
        emoji: '😺',
        text: 'Katze',
    },
    {
        emoji: '😸',
        text: 'Katze',
    },
    {
        emoji: '😹',
        text: 'Katze',
    },
    {
        emoji: '😻',
        text: 'Katze',
    },
    {
        emoji: '😼',
        text: 'Katze',
    },
    {
        emoji: '😽',
        text: 'Katze',
    },
    {
        emoji: '🙀',
        text: 'Katze',
    },
    {
        emoji: '😿',
        text: 'Katze',
    },
    {
        emoji: '😾',
        text: 'Katze',
    },
    {
        emoji: '🐈',
        text: 'Katze',
    },
    {
        emoji: '🐭',
        text: 'Nager',
    },
    {
        emoji: '🐹',
        text: 'Nager',
    },
    {
        emoji: '🐰',
        text: 'Nager',
    },
    {
        emoji: '🐇',
        text: 'Nager',
    },
    {
        emoji: '🐁',
        text: 'Nager',
    },
    {
        emoji: '🐀',
        text: 'Nager',
    },
    {
        emoji: '🐦',
        text: 'Vogel',
    },
    {
        emoji: '🕊️',
        text: 'Vogel',
    },
    {
        emoji: '💩',
        text: 'Toilette',
    },
    {
        emoji: '🐷',
        text: 'Schwein',
    },
    {
        emoji: '🐽',
        text: 'Schwein',
    },
    {
        emoji: '🐖',
        text: 'Schwein',
    },
    {
        emoji: '🎉',
        text: 'Party',
    },
    {
        emoji: '🎊',
        text: 'Party',
    },
    {
        emoji: '🎁',
        text: 'Geschenk',
    },
    {
        emoji: '🐮',
        text: 'Rind',
    },
    {
        emoji: '🐄',
        text: 'Rind',
    },
    {
        emoji: '🔋',
        text: 'Batterien',
    },
    {
        emoji: '☀️',
        text: 'Sonne',
    },
    {
        emoji: '🐟',
        text: 'Fisch',
    },
    {
        emoji: '🛁',
        text: 'Dusche',
    },
    {
        emoji: '🍦',
        text: 'Glace',
    },
    {
        emoji: '🥖',
        text: 'Brot',
    },
    {
        emoji: '☕️',
        text: 'Kaffee',
    },
    {
        emoji: '🍯',
        text: 'Honig',
    },
    {
        emoji: '🥒',
        text: 'Gurke',
    },
    {
        emoji: '🍗 ',
        text: 'Fleisch',
    },
    {
        emoji: '🎮',
        text: 'Spiele',
    },
    {
        emoji: '🎲',
        text: 'Spiele',
    },
    {
        emoji: '😪',
        text: 'Taschentücher',
    },
    {
        emoji: '🤧',
        text: 'Taschentücher',
    },
    {
        emoji: '🤕',
        text: 'Pflaster',
    },
    {
        emoji: '👶',
        text: 'Baby',
    },
    {
        emoji: '💅🏻',
        text: 'Nagellack',
    },
    {
        emoji: '👩🏼‍🌾',
        text: 'Bio',
    },
    {
        emoji: '👨🏼‍🌾',
        text: 'Bio',
    },
    {
        emoji: '🐔',
        text: 'Poulet',
    },
    {
        emoji: '🐥',
        text: 'Poulet',
    },
    {
        emoji: '🦐',
        text: 'Crevetten',
    },
    {
        emoji: '🐓',
        text: 'Poulet',
    },
    {
        emoji: '🎅',
        text: 'Weihnachten',
    },
    {
        emoji: '🎄',
        text: 'Weihnachten',
    },
    {
        emoji: '🐑',
        text: 'Schaf',
    },
    {
        emoji: '🍫',
        text: 'Schokolade',
    },
    {
        emoji: '✂️',
        text: 'Papeterie',
    },
    {
        emoji: '✏️',
        text: 'Papeterie',
    },
    {
        emoji: '📎',
        text: 'Papeterie',
    },
    {
        emoji: '💊',
        text: 'Vitamin',
    },
    {
        emoji: '🚽',
        text: 'Toilette',
    },
];



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/emojis-to-german.js